<template>
  <v-app>
    <component :is="layout" />
  </v-app>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Auth from './views/Auth.vue';

const route = useRoute();

const layout = computed(() => {
  if (route.meta.layout) {
    return route.meta.layout;
  } else {
    return Auth;
  }
})
</script>

<style>

* {
  scrollbar-width: thin;
  scrollbar-color: #9E9E9E #FFFFFF;
}
*::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}
*::-webkit-scrollbar-track {
  background: #FFFFFF;
}
*::-webkit-scrollbar-thumb {
  background-color: #9E9E9E;
  border-radius: 10px;
  border: 2.5px solid #FFFFFF;
}

</style>
